import { DateDisplay } from "../../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { ArticleExtraData } from "../../../../../../articlePage/stateInterfaces";
import { getTranslation } from "../../../autoTickerRowWidget/autoTickerRowTranslations";
import { minutesDiff } from "../newsFlashAndTwentyFourSevenMobileComponenta";
import { getImageUrl } from "config/apiUrls";
import { MediaContentTypes } from "../../../../../../constants/contentTypes";
import { SiteVideoData } from "../../../../../interfaces";
import { categoryObj } from "../../../newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { disablePageRefresh, enablePageRefresh } from "../../../../../siteWidgets/siteWidgetUtils";
import { MediaOverlayDisplay } from "../../../../mediaOverlayDisplay/mediaOverlayDisplay";
import { NewsFlashShareMenu } from "./newsFlashShareMenu";
import * as ReactDOM from "react-dom";
import { isWcmEditor } from "../../../../../../config/serverConfig"

interface NewsFlashSpecialMobileSlotItemProps {
    isLTR: boolean
    domain: string
    article: ArticleExtraData
    nextRoof: string
    languageCode: string
    previousRoof: string
    roofOngoingEvent: boolean
    isMobileWeb?: boolean
    isFlashPage?: boolean
    openedItemId?: string // used by row item
    onRowItemToggle?: (articleId: string) => void // used by row item
    isFirstInterval?: boolean
    accordionOpenState?: boolean
    highlightingDuration?: number
    handleCarouselAutoplay?: (shouldCarouselAutoplay: boolean) => void
}

interface NewsFlashSpecialMobileSlotItemState {
    isExpandOpen: boolean
    shouldDisplayArticle: boolean
    isFirstRender: boolean
    isOverlayOpen: boolean
}

export class NewsFlashSpecialSlotItem extends React.Component<NewsFlashSpecialMobileSlotItemProps, NewsFlashSpecialMobileSlotItemState> {

    constructor(props) {
        super(props);
        this.state = {
            isFirstRender: true,
            isOverlayOpen: false,
            shouldDisplayArticle: true,
            isExpandOpen: props.accordionOpenState || false,
        }
    }

    componentDidMount() {
        if (!this.props.isFlashPage && this.state.isFirstRender) {
            this.firstRender();
            this.setState({ isFirstRender: false })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.accordionOpenState !== prevProps.accordionOpenState) {
            this.setState({ isExpandOpen: this.props.accordionOpenState });
        }
    }

    private onSlotClickHandler = (e: React.MouseEvent) => {
        const { article: { title, articleId }, onRowItemToggle } = this.props;
        const { isExpandOpen } = this.state;

        this.dispatchCustomEvent(title);
        if (onRowItemToggle) {
            onRowItemToggle(articleId);
        } else {
            this.setState({ isExpandOpen: !isExpandOpen });
        }
    }

    private dispatchCustomEvent = (title: string) => {
        const { isExpandOpen } = this.state;
        document.dispatchEvent(
            new CustomEvent("newsFlashesTwentyFourSevenReadMoreChange",
                {
                    detail: {
                        action: isExpandOpen ? "Collapse" : "Expand",
                        label: title,
                    }
                }
            ))
    }

    private firstRender = () => {
        const { isFirstInterval, article, highlightingDuration } = this.props;
        const isNow = minutesDiff(article) === 0;
        const isUpToFiveMin = highlightingDuration && minutesDiff(article) < highlightingDuration;

        if (isFirstInterval) {
            isUpToFiveMin && this.setState({ shouldDisplayArticle: false });

            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true })
            }, 3000)
        } else {
            isNow && this.setState({ shouldDisplayArticle: false });

            setTimeout(() => {
                this.setState({ shouldDisplayArticle: true });
            }, 3000)
        }
    }

    private getPosterUrl = () => {
        const { specialData, promotionImageDetails, video } = this.props.article;
        const { mediaLinkType, mediaProportion } = specialData;
        const mediaPosterSize = mediaLinkType !== "none" && mediaLinkType !== undefined && mediaProportion === "9:16" ? { w: 207, h: 370 } : { w: 448, h: 251 };

        if (mediaLinkType !== "none" && mediaLinkType !== undefined) {
            if (mediaLinkType === "image") {
                return getImageUrl(promotionImageDetails, mediaPosterSize);
            } else if (mediaLinkType === "video" && video && video[0]) {
                return video[0].posterSrc;
            }
        }
    }

    private openMediaDisplayView = (e) => {
        e.stopPropagation();
        this.setState({ isOverlayOpen: true });
        this.props.handleCarouselAutoplay(false);
        disablePageRefresh();

    }

    private closeMediaDisplayView = (e) => {
        e.stopPropagation();
        this.setState({ isOverlayOpen: false });
        this.props.handleCarouselAutoplay(true);
        enablePageRefresh();
    }

    public render() {
        const { isExpandOpen, shouldDisplayArticle, isOverlayOpen } = this.state;
        const { article, languageCode, highlightingDuration, isLTR, domain, nextRoof, previousRoof, roofOngoingEvent, isMobileWeb, isFlashPage, openedItemId, onRowItemToggle } = this.props;
        const { articleId, roof, title, subTitle, dateUpdatedOnSite, plainText, author, specialData, category, video, publishedLink, promotionImageDetails } = article;
        const { mediaLinkType, videoBehaivior, videoCredit, videoOriginalCaption, linkProperties, linkTargetProperties } = specialData;
        const newItem = highlightingDuration && minutesDiff(article) < highlightingDuration;
        const isItemOpen = onRowItemToggle ? openedItemId === articleId : isExpandOpen;
        const isNewItem = newItem ? "now" : "";
        const isOpen = isItemOpen ? "open" : "";
        const hasRoof = roof && roof.length > 0 ? "has-roof" : "";
        const lang = languageCode ? languageCode.slice(0, 2) : "he";
        const date = newItem ? getTranslation(lang, "Now") : <DateDisplay date={dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
        const isAuthor = author && author.length > 0;
        const newCategory: categoryObj = { id: category.id, name: category.textToShow, categoryColor: "" };
        const isFirstRoofInSequence = !roofOngoingEvent ? true : previousRoof !== roof;
        const shouldShowConnectorLine = roofOngoingEvent && roof && nextRoof === roof;
        const isHomePageDesktopFlashes = !isMobileWeb && !isFlashPage;

        const emptyMedia: any = { url: "", mediaType: MediaContentTypes.MEDIA_IMAGE, title: "", poster: "", promoPath: "", duration: 0 } as any
        let videoMedia: SiteVideoData;
        let videoItem;

        if (video && video[0]) {
            videoMedia = {
                ...videoBehaivior,
                mediaType: MediaContentTypes.MEDIA_VIDEO,
                mediaId: video[0].mediaVideoId,
                credit: videoCredit,
                url: video[0].main_link,
                downGradeUrl: video[0].low_res_link,
                title: title || videoOriginalCaption,
                poster: video[0].posterSrc,
                promoPath: video[0].promoPath,
                duration: video[0].duration,
                videoPageId: video[0].videoPageId,
                videoType: "vertical_video",
            } as SiteVideoData

            videoItem = {
                media: videoMedia ? videoMedia : emptyMedia,
                title: title,
                titleLink: undefined, //linkProperties.type !== "NONE" ? getUrl(linkProperties) : undefined,
                subTitle: subTitle,
                titleTargetLink: linkTargetProperties,
                itemId: articleId
            }
        }

        const titleToDisplay = isHomePageDesktopFlashes && roof ?
            <div className="mixed-titles-container">
                <span className="dot"></span>
                <span className="roofTitle">{roof}</span>
                <span className="separator"></span>
                <span className="slotTitle">{title}</span>
            </div>
            :
            <div className="slotTitle">{title}</div>

        const mediaOverlayDisplay = (
            <MediaOverlayDisplay
                isLTR={isLTR}
                domain={domain}
                showPrerollAds={true}
                articleId={articleId}
                isMobile={isMobileWeb}
                category={newCategory}
                videoItems={videoItem}
                mediaType={mediaLinkType}
                languageCode={languageCode}
                isSingleVideoDisplay={true}
                isOverlayOpen={isOverlayOpen}
                isTitleVisible={title.length > 0}
                imageDetails={promotionImageDetails}
                isSubTitleVisible={subTitle.length > 0}
                onMediaOverlayClose={this.closeMediaDisplayView}
            />)

        return (
            <>
                {shouldDisplayArticle &&
                    <div className={`slotView special-flash-item ${isOpen} ${isNewItem} ${hasRoof}`} data_analytics_id={articleId}>
                        {!isHomePageDesktopFlashes && roof &&
                            <div className="titles-container">
                                <div className={`dot ${isFirstRoofInSequence ? "" : "small-dot"}`}></div>
                                {shouldShowConnectorLine && <div className="roof-connector-line" />}
                            </div>
                        }

                        {!isHomePageDesktopFlashes && isFirstRoofInSequence && <span className="roofTitle">{roof}</span>}

                        <div className="textDiv" onClick={this.onSlotClickHandler}>
                            <div className="date-expand-btn-container">
                                <div className="dateView">{date}</div>

                                <div className="buttonExpand" />
                            </div>

                            <div className="title-poster-container">
                                {titleToDisplay}

                                {mediaLinkType !== "none" && mediaLinkType !== undefined  &&
                                    <div className="image-container" onClick={this.openMediaDisplayView} data_mediaid_analitycs={!isWcmEditor() && mediaLinkType==="video" && videoItem.mediaId ? videoItem.mediaId : ""}>
                                        <img className="posterImage" src={this.getPosterUrl()} alt={title} />
                                        {mediaLinkType === "video" && <div className="video-icon"></div>}
                                        {mediaLinkType === "image" && <div className="expand-image-icon"></div>}
                                    </div>
                                }
                            </div>

                            <div className={`slotContent ${isOpen ? "show" : ""}`}>
                                <div className="slotText">
                                    {plainText}

                                    {isAuthor && <div className="author">{`(${author})`}</div>}
                                </div>

                                {isMobileWeb &&
                                    <NewsFlashShareMenu
                                        title={title}
                                        articleId={articleId}
                                        shareUrl={publishedLink}
                                        isMobileWeb={isMobileWeb}
                                        isNew={isNewItem === "now"}
                                    />
                                }
                            </div>

                            {!isMobileWeb &&
                                <NewsFlashShareMenu
                                    title={title}
                                    articleId={articleId}
                                    shareUrl={publishedLink}
                                    isMobileWeb={isMobileWeb}
                                    isNew={isNewItem === "now"}
                                    className={isItemOpen ? "show-share" : "hide-share"}
                                />
                            }
                        </div>


                        {(mediaLinkType === "image" || mediaLinkType === "video") &&
                            (isHomePageDesktopFlashes ?
                                ReactDOM.createPortal(mediaOverlayDisplay, document.querySelector("body"), `mediaOverlayDisplay_${articleId}`)
                                :
                                mediaOverlayDisplay
                            )
                        }
                    </div>
                }
            </>
        )
    }
}